import {TranslateCellComponent} from '@shared/components/table/cells/translate-cell/translate-cell.component';
import {Columns} from '@shared/interfaces/table/column-config';

export const assettypePartial: Columns<any> = {
  title: 'meteringPoint.assetType.title',
  key: 'assetType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: 'meteringPoint.assetType.notSpecified',
    steamturbinebackpressuremode: 'meteringPoint.assetType.steamTurbineBackPressureMode',
    gasturbine: 'meteringPoint.assetType.gasturbine',
    combinedcycle: 'meteringPoint.assetType.combinedCycle',
    combustionenginegas: 'meteringPoint.assetType.combustionEngineGas',
    steamturbinewithcondensation: 'meteringPoint.assetType.steamTurbineWithCondensation',
    boiler: 'meteringPoint.assetType.boiler',
    stirlingengine: 'meteringPoint.assetType.stirlingEngine',
    permanentconnectedelectricalenergystoragefacilities: 'meteringPoint.assetType.permanentConnectedElectricalEnergyStorageFacilities',
    temporaryconnectedelectricalenergystoragefacilities: 'meteringPoint.assetType.temporaryConnectedElectricalEnergyStorageFacilities',
    fuelcells: 'meteringPoint.assetType.fuelCells',
    photovoltaiccells: 'meteringPoint.assetType.photovoltaicCells',
    windturbines: 'meteringPoint.assetType.windTurbines',
    hydroelectricpower: 'meteringPoint.assetType.hydroelectricPower',
    wavepower: 'meteringPoint.assetType.wavePower',
    mixedproduction: 'meteringPoint.assetType.mixedProduction',
    productionwithelectricalenergystoragefacilities: 'meteringPoint.assetType.productionWithElectricalEnergyStorageFacilities',
    powertox: 'meteringPoint.assetType.powerToX',
    regenerativedemandfacility: 'meteringPoint.assetType.regenerativeDemandFacility',
    combustionenginediesel: 'meteringPoint.assetType.combustionEngineDiesel',
    combustionenginebio: 'meteringPoint.assetType.combustionEngineBio',
    unknowntecnology: 'meteringPoint.assetType.unknownTecnology'
  }
}
